import { useAuth0 } from "@auth0/auth0-react";
import { Menu, Transition } from "@headlessui/react";
import { useTranslation } from "@sg/i18n";
import { ProfileIcon } from "@sg/ui";
import clsx from "clsx";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ROUTE } from "~/routes/config";
import useAuthStore from "~/store/auth";
import { logoutCleaner } from "~/util/logout";

export function SidebarUserMenu() {
  const { t } = useTranslation();
  const userInfo = useAuthStore((state) => state.userInfo);
  const logoutStore = useAuthStore((state) => state.logout);
  const { logout } = useAuth0();

  const userNavigation = [
    { name: t("nav:profile"), href: ROUTE.PROFILE },
    /*
    {
      name: t("nav:api"),
      onClick: () => {
        window.open(getApiDocsUrl(), "_blank");
      },
    },
     */
    {
      name: t("nav:sign_out"),
      onClick: () => {
        logout({ returnTo: window.location.origin });
        logoutStore();
        logoutCleaner();
      },
    },
  ];

  return (
    <Menu as="div" className="relative z-20">
      <div className="p-4">
        <Menu.Button className="control-gradient w-full flex items-center gap-x-2 text-sm font-semibold leading-6 p-3">
          <span className="sr-only">Open user menu</span>
          <ProfileIcon />
          <span className="lg:block hidden max-w-[300px] text-ellipsis truncate" title={userInfo.name}>
            {userInfo.name}
          </span>
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-right absolute right-0 sm:right-1 mt-2 w-[240px] overflow-x-scroll rounded-md shadow-lg py-1 bg-popover ring-1 ring-border ring-opacity-5 focus:outline-none lg:bottom-full">
            <div className="px-4 py-2 border-b border-solid border-border">
              <div className="text-xs font-medium text-black dark:text-white max-w-[230px] truncate">
                {userInfo.first_name + " " + userInfo.last_name}
              </div>
              <div className="text-xs font-medium text-foreground max-w-[230px] truncate">{userInfo.email}</div>
            </div>
            {userNavigation.map((item) => (
              <Menu.Item key={item.name}>
                {({ active }) => (
                  <Link
                    onClick={item.onClick}
                    to={item.href || "#"}
                    className={clsx(
                      active ? "bg-gray-100 dark:bg-zinc-800" : "",
                      "block px-4 py-2 text-sm text-foreground"
                    )}
                  >
                    {item.name}
                  </Link>
                )}
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </div>
    </Menu>
  );
}
